(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('decisione', {
            parent: 'entity',
            url: '/decisione?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.decisione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/decisione/decisiones.html',
                    controller: 'DecisioneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc', // inca$ - default order
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('decisione');
                    $translatePartialLoader.addPart('tipoOrdine');
                    $translatePartialLoader.addPart('tipoDecisione');
                    $translatePartialLoader.addPart('statoDecisione');
                    $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('decisione-detail', {
            parent: 'entity',
            url: '/decisione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.decisione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/decisione/decisione-detail.html',
                    controller: 'DecisioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('decisione');
                    $translatePartialLoader.addPart('tipoOrdine');
                    $translatePartialLoader.addPart('tipoDecisione');
                    $translatePartialLoader.addPart('statoDecisione');
                    $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Decisione', function($stateParams, Decisione) {
                    return Decisione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'decisione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('decisione-detail.edit', {
            parent: 'decisione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decisione/decisione-dialog.html',
                    controller: 'DecisioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Decisione', function(Decisione) {
                            return Decisione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('decisione.new', {
            parent: 'decisione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decisione/decisione-dialog.html',
                    controller: 'DecisioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                data: null,
                                tipoOrdine: null,
                                tipoDecisione: null,
                                stato: null,
                                funzionaleAllaRicerca: false,
                                pubblicazione: false,
                                oggetto: null,
                                descrizione: null,
                                cig: null,
                                cup: null,
                                dettaglioFondi: null,
                                spesa: null,
                                spesaAutoritaVigilanza: null,
                                giorniConsegna: null,
                                luogoConsegna: null,
                                motivazioneRifiuto: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                versioneRecord: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('decisione', null, { reload: 'decisione' });
                }, function() {
                    $state.go('decisione');
                });
            }]
        })
        .state('decisione.edit', {
            parent: 'decisione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decisione/decisione-dialog.html',
                    controller: 'DecisioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Decisione', function(Decisione) {
                            return Decisione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('decisione', null, { reload: 'decisione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('decisione.delete', {
            parent: 'decisione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decisione/decisione-delete-dialog.html',
                    controller: 'DecisioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Decisione', function(Decisione) {
                            return Decisione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('decisione', null, { reload: 'decisione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
